// extracted by mini-css-extract-plugin
export default {"card":"Discord_card__owlou","card__header":"Discord_card__header__O9cO7","card__title":"Discord_card__title__Be-UC","card__image":"Discord_card__image__zj3Qh"};